// Fixed customer UI strings; no owner content or executable translations.
export const customerEnglish = {
  "copy.Email": "Email",
  "copy.Password": "Password",
  "copy.Username": "Username",
  "copy.Rememberme": "Remember me",
  "copy.Donothaveanaccount": "Do not have an account?",
  "copy.Confirmpassword": "Confirm password",
  "copy.Signin": "Sign in",
  "copy.Signup": "Sign up",
  "copy.SignIn": "Sign In",
  "copy.SIGNUP": "SIGN UP",
  "copy.Creating": "Creating...",
  "copy.Signingin": "Signing in...",
  "copy.WelcomeBack": "Welcome Back",
  "copy.TwoFactorAuthentication": "Two-Factor Authentication",
  "copy.Signintoyouraccount": "Sign in to your account",
  "copy.Enteroneofyoursavedonetimerecoverycodes": "Enter one of your saved one-time recovery codes",
  "copy.Enterthecodefromyourauthenticatorapp": "Enter the code from your authenticator app",
  "copy.Forgotpassword": "Forgot password?",
  "copy.Resendverificationemail": "Resend verification email",
  "copy.RecoveryCode": "Recovery Code",
  "copy.VerificationCode": "Verification Code",
  "copy.Savedrecoverycode": "Saved recovery code",
  "copy.Verifying": "Verifying...",
  "copy.Signinwithrecoverycode": "Sign in with recovery code",
  "copy.Verify": "Verify",
  "copy.Useauthenticatorcode": "Use authenticator code",
  "copy.Usearecoverycode": "Use a recovery code",
  "copy.Backtologin": "Back to login",
  "copy.Donthaveanaccount": "Don't have an account?",
  "copy.Alreadyhaveanaccount": "Already have an account?",
  "copy.TermsofService": "Terms of Service",
  "copy.Ihavereadandagreedwith": "I have read and agreed with",
  "copy.Savingreferral": "Saving referral...",
  "copy.Retryreferral": "Retry referral",
  "copy.Loadingregistrationsettings": "Loading registration settings...",
  "copy.Retrysettings": "Retry settings",
  "copy.Retryverification": "Retry verification",
  "copy.Registrationisdisabledforthispanel": "Registration is disabled for this panel.",
  "copy.Showpassword": "Show password",
  "copy.Hidepassword": "Hide password",
  "copy.Showpasswordconfirmation": "Show password confirmation",
  "copy.Hidepasswordconfirmation": "Hide password confirmation",
  "copy.Firstname": "First name",
  "copy.Lastname": "Last name",
  "copy.Phone": "Phone",
  "copy.Skype": "Skype",
  "copy.CheckYourEmail": "Check Your Email",
  "copy.ForgotPassword": "Forgot Password?",
  "copy.Checkyouremailifyouraccountiseligible": "Check your email if your account is eligible",
  "copy.Enteryouremailandwellsendyouaresetlink": "Enter your email and we'll send you a reset link",
  "copy.Loadingaccountsettings": "Loading account settings...",
  "copy.PasswordresetrequestsaredisabledforthispanelContactsupport": "Password reset requests are disabled for this panel. Contact support.",
  "copy.BacktoLogin": "Back to Login",
  "copy.EmailAddress": "Email Address",
  "copy.Sending": "Sending...",
  "copy.SendResetLink": "Send Reset Link",
  "copy.Verifyyouremail": "Verify your email",
  "copy.Confirmtheaccountnamedinyourverificationemailbeforesigningin": "Confirm the account named in your verification email before signing in.",
  "copy.ChecktheaccountnameandpanelinthenewestemailAlinkforanotheraccountwillnotactivatetheoneyouwanttouse": "Check the account name and panel in the newest email. A link for another account will not activate the one you want to use.",
  "copy.IfyoualreadyconfirmedtheaccountnamedinthatemailtrysigninginOtherwiserequestanewlinkusingthataccountsregisteredemailaddress": "If you already confirmed the account named in that email, try signing in. Otherwise, request a new link using that account's registered email address.",
  "copy.Entertheemailaddressyouusedtoregisteronthispanel": "Enter the email address you used to register on this panel.",
  "copy.Registeredemail": "Registered email",
  "copy.Pleasewait": "Please wait...",
  "copy.Confirmtheaccountinthisemail": "Confirm the account in this email",
  "copy.Requestanewlink": "Request a new link",
  "copy.Signintotheverifiedaccount": "Sign in to the verified account",
  "copy.Backtosignin": "Back to sign in",
  "copy.Balance": "Balance",
  "copy.NewOrder": "New Order",
  "copy.Active": "Active",
  "copy.TotalSpent": "Total Spent",
  "copy.TotalOrders": "Total Orders",
  "copy.InProgress": "In Progress",
  "copy.Pending": "Pending",
  "copy.ActivityOverview": "Activity Overview",
  "copy.Ordersinthelast7days": "Orders in the last 7 days",
  "copy.RecentOrders": "Recent Orders",
  "copy.Viewall": "View all",
  "copy.Noordersyet": "No orders yet",
  "copy.Placeyourfirstorder": "Place your first order",
  "copy.Placeanorder": "Place an order",
  "copy.MassOrder": "Mass Order",
  "copy.Bulkorders": "Bulk orders",
  "copy.AddFunds": "Add Funds",
  "copy.Topupbalance": "Top up balance",
  "copy.ViewOrders": "View Orders",
  "copy.Orderhistory": "Order history",
  "copy.AllCategories": "All Categories",
  "copy.Category": "Category",
  "copy.Search": "Search",
  "copy.Favorite": "Favorite",
  "copy.ID": "ID",
  "copy.Service": "Service",
  "copy.Rateper1000": "Rate per 1000",
  "copy.Minorder": "Min order",
  "copy.Maxorder": "Max order",
  "copy.Averagetime": "Average time",
  "copy.Description": "Description",
  "copy.Loadingservices": "Loading services...",
  "copy.Noservicesfound": "No services found",
  "copy.Nodescriptionprovided": "No description provided.",
  "copy.Hidedetails": "Hide details",
  "copy.Moredetails": "More details",
  "copy.Start": "Start:",
  "copy.Speed": "Speed:",
  "copy.Quality": "Quality:",
  "copy.Refill": "Refill:",
  "copy.Link": "Link:",
  "copy.Notspecified": "Not specified",
  "copy.Yes": "Yes",
  "copy.No": "No",
  "copy.NoservicedescriptionhasbeenprovidedContactsupportfordetails": "No service description has been provided. Contact support for details.",
  "copy.Refillisenabledforthisservice": "Refill is enabled for this service.",
  "copy.Refillisnotenabledforthisservice": "Refill is not enabled for this service.",
  "copy.Enterthelinkrequiredbythisservice": "Enter the link required by this service",
  "copy.Checktheservicedescriptionfortherequiredlinktype": "Check the service description for the required link type.",
  "copy.Supporttickets": "Support tickets",
  "copy.Retryformsettings": "Retry form settings",
  "copy.Loadingticketform": "Loading ticket form...",
  "copy.NewsupportticketsaredisabledforthisaccountExistingconversationsremainavailable": "New support tickets are disabled for this account. Existing conversations remain available.",
  "copy.NoticketcategoriesareconfiguredContactthepaneladministrator": "No ticket categories are configured. Contact the panel administrator.",
  "copy.Newticket": "New ticket",
  "copy.Subject": "Subject",
  "copy.Subcategory": "Subcategory",
  "copy.OrderID": "Order ID",
  "copy.Message": "Message",
  "copy.Attachfiles": "Attach files",
  "copy.Attachfilestonewticket": "Attach files to new ticket",
  "copy.PNGJPEGPDForUTF8textUpto5MiBperfileand10filesperticket": "PNG, JPEG, PDF or UTF-8 text. Up to 5 MiB per file and 10 files per ticket.",
  "copy.Submitting": "Submitting…",
  "copy.Submitticket": "Submit ticket",
  "copy.Tickethistory": "Ticket history",
  "copy.Yourtickets": "Your tickets",
  "copy.Searchtickets": "Search tickets",
  "copy.TicketsubjectororderID": "Ticket, subject or order ID",
  "copy.EnterorderIDoptional": "Enter order ID (optional)",
  "copy.Status": "Status",
  "copy.Ticketstatus": "Ticket status",
  "copy.Allstatuses": "All statuses",
  "copy.Refreshtickets": "Refresh tickets",
  "copy.Loadingtickets": "Loading tickets…",
  "copy.Noticketsmatchthesefilters": "No tickets match these filters.",
  "copy.Previoustickets": "Previous tickets",
  "copy.Nexttickets": "Next tickets",
  "copy.Ticketconversation": "Ticket conversation",
  "copy.Backtotickets": "Back to tickets",
  "copy.Refreshconversation": "Refresh conversation",
  "copy.Loadingconversation": "Loading conversation…",
  "copy.Support": "Support",
  "copy.You": "You",
  "copy.Previousmessages": "Previous messages",
  "copy.Nextmessages": "Next messages",
  "copy.ThisticketisclosedCreateanotherticketifyouneedhelp": "This ticket is closed. Create another ticket if you need help.",
  "copy.Replytoticket": "Reply to ticket",
  "copy.Reply": "Reply",
  "copy.Saving": "Saving…",
  "copy.Sendreply": "Send reply",
  "copy.Confirmticketclosure": "Confirm ticket closure",
  "copy.ClosethisticketReplieswillbedisabled": "Close this ticket? Replies will be disabled.",
  "copy.Confirmclose": "Confirm close",
  "copy.Keepopen": "Keep open",
  "copy.Closeticket": "Close ticket",
  "copy.Retrycontent": "Retry content",
  "copy.Loadingcontent": "Loading content...",
  "copy.Blog": "Blog",
  "copy.Nopublishedarticlesyet": "No published articles yet.",
  "copy.Pageunavailable": "Page unavailable",
  "copy.Thispageishiddenunpublishedorunavailabletothisaccount": "This page is hidden, unpublished, or unavailable to this account.",
  "copy.Nocontenthasbeenpublishedforthispageyet": "No content has been published for this page yet.",
  "copy.Account": "Account",
  "copy.Logout": "Logout",
  "copy.Togglenavigation": "Toggle navigation",
  "copy.Retrymenu": "Retry menu"
};
export const customerArabic = {
  "copy.Email": "البريد الإلكتروني",
  "copy.Password": "كلمة المرور",
  "copy.Username": "اسم المستخدم",
  "copy.Rememberme": "تذكرني",
  "copy.Donothaveanaccount": "ليس لديك حساب؟",
  "copy.Confirmpassword": "تأكيد كلمة المرور",
  "copy.Signin": "تسجيل الدخول",
  "copy.Signup": "إنشاء حساب",
  "copy.SignIn": "تسجيل الدخول",
  "copy.SIGNUP": "إنشاء حساب",
  "copy.Creating": "جارٍ إنشاء الحساب...",
  "copy.Signingin": "جارٍ تسجيل الدخول...",
  "copy.WelcomeBack": "مرحبًا بعودتك",
  "copy.TwoFactorAuthentication": "التحقق بخطوتين",
  "copy.Signintoyouraccount": "سجّل الدخول إلى حسابك",
  "copy.Enteroneofyoursavedonetimerecoverycodes": "أدخل أحد رموز الاسترداد المحفوظة التي تُستخدم مرة واحدة",
  "copy.Enterthecodefromyourauthenticatorapp": "أدخل الرمز من تطبيق المصادقة",
  "copy.Forgotpassword": "نسيت كلمة المرور؟",
  "copy.Resendverificationemail": "إعادة إرسال رسالة التفعيل",
  "copy.RecoveryCode": "رمز الاسترداد",
  "copy.VerificationCode": "رمز التحقق",
  "copy.Savedrecoverycode": "رمز الاسترداد المحفوظ",
  "copy.Verifying": "جارٍ التحقق...",
  "copy.Signinwithrecoverycode": "الدخول باستخدام رمز الاسترداد",
  "copy.Verify": "تحقق",
  "copy.Useauthenticatorcode": "استخدام تطبيق المصادقة",
  "copy.Usearecoverycode": "استخدام رمز استرداد",
  "copy.Backtologin": "العودة لتسجيل الدخول",
  "copy.Donthaveanaccount": "ليس لديك حساب؟",
  "copy.Alreadyhaveanaccount": "لديك حساب بالفعل؟",
  "copy.TermsofService": "شروط الخدمة",
  "copy.Ihavereadandagreedwith": "قرأت ووافقت على",
  "copy.Savingreferral": "جارٍ حفظ الإحالة...",
  "copy.Retryreferral": "إعادة محاولة حفظ الإحالة",
  "copy.Loadingregistrationsettings": "جارٍ تحميل إعدادات التسجيل...",
  "copy.Retrysettings": "إعادة تحميل الإعدادات",
  "copy.Retryverification": "إعادة محاولة التحقق",
  "copy.Registrationisdisabledforthispanel": "التسجيل معطّل في هذه اللوحة.",
  "copy.Showpassword": "إظهار كلمة المرور",
  "copy.Hidepassword": "إخفاء كلمة المرور",
  "copy.Showpasswordconfirmation": "إظهار تأكيد كلمة المرور",
  "copy.Hidepasswordconfirmation": "إخفاء تأكيد كلمة المرور",
  "copy.Firstname": "الاسم الأول",
  "copy.Lastname": "اسم العائلة",
  "copy.Phone": "الهاتف",
  "copy.Skype": "سكايب",
  "copy.CheckYourEmail": "تحقّق من بريدك الإلكتروني",
  "copy.ForgotPassword": "نسيت كلمة المرور؟",
  "copy.Checkyouremailifyouraccountiseligible": "تحقّق من بريدك إذا كان حسابك مؤهلًا",
  "copy.Enteryouremailandwellsendyouaresetlink": "أدخل بريدك الإلكتروني لطلب رابط الاستعادة",
  "copy.Loadingaccountsettings": "جارٍ تحميل إعدادات الحساب...",
  "copy.PasswordresetrequestsaredisabledforthispanelContactsupport": "استعادة كلمة المرور معطّلة لهذه اللوحة. تواصل مع الدعم.",
  "copy.BacktoLogin": "العودة لتسجيل الدخول",
  "copy.EmailAddress": "البريد الإلكتروني",
  "copy.Sending": "جارٍ الإرسال...",
  "copy.SendResetLink": "إرسال رابط الاستعادة",
  "copy.Verifyyouremail": "تأكيد البريد الإلكتروني",
  "copy.Confirmtheaccountnamedinyourverificationemailbeforesigningin": "أكّد الحساب المذكور في رسالة التفعيل قبل تسجيل الدخول.",
  "copy.ChecktheaccountnameandpanelinthenewestemailAlinkforanotheraccountwillnotactivatetheoneyouwanttouse": "تحقّق من اسم الحساب واللوحة في أحدث رسالة. رابط حساب آخر لن يفعّل الحساب الذي تريد استخدامه.",
  "copy.IfyoualreadyconfirmedtheaccountnamedinthatemailtrysigninginOtherwiserequestanewlinkusingthataccountsregisteredemailaddress": "إن سبق تأكيد الحساب المذكور في الرسالة فجرّب تسجيل الدخول. وإلا اطلب رابطًا جديدًا باستخدام بريد ذلك الحساب.",
  "copy.Entertheemailaddressyouusedtoregisteronthispanel": "أدخل البريد الإلكتروني الذي سجّلت به في هذه اللوحة.",
  "copy.Registeredemail": "البريد المسجّل",
  "copy.Pleasewait": "يرجى الانتظار...",
  "copy.Confirmtheaccountinthisemail": "تأكيد الحساب المذكور في الرسالة",
  "copy.Requestanewlink": "طلب رابط جديد",
  "copy.Signintotheverifiedaccount": "الدخول إلى الحساب المؤكّد",
  "copy.Backtosignin": "العودة لتسجيل الدخول",
  "copy.Balance": "الرصيد",
  "copy.NewOrder": "طلب جديد",
  "copy.Active": "نشط",
  "copy.TotalSpent": "إجمالي الإنفاق",
  "copy.TotalOrders": "إجمالي الطلبات",
  "copy.InProgress": "قيد التنفيذ",
  "copy.Pending": "قيد الانتظار",
  "copy.ActivityOverview": "ملخص النشاط",
  "copy.Ordersinthelast7days": "الطلبات خلال آخر 7 أيام",
  "copy.RecentOrders": "الطلبات الأخيرة",
  "copy.Viewall": "عرض الكل",
  "copy.Noordersyet": "لا توجد طلبات بعد",
  "copy.Placeyourfirstorder": "أنشئ طلبك الأول",
  "copy.Placeanorder": "إنشاء طلب",
  "copy.MassOrder": "طلبات متعددة",
  "copy.Bulkorders": "طلبات بالجملة",
  "copy.AddFunds": "إضافة رصيد",
  "copy.Topupbalance": "شحن الرصيد",
  "copy.ViewOrders": "عرض الطلبات",
  "copy.Orderhistory": "سجل الطلبات",
  "copy.AllCategories": "جميع الفئات",
  "copy.Category": "الفئة",
  "copy.Search": "بحث",
  "copy.Favorite": "المفضلة",
  "copy.ID": "المعرّف",
  "copy.Service": "الخدمة",
  "copy.Rateper1000": "السعر لكل 1000",
  "copy.Minorder": "الحد الأدنى",
  "copy.Maxorder": "الحد الأقصى",
  "copy.Averagetime": "متوسط المدة",
  "copy.Description": "الوصف",
  "copy.Loadingservices": "جارٍ تحميل الخدمات...",
  "copy.Noservicesfound": "لم تُعثر على خدمات",
  "copy.Nodescriptionprovided": "لا يوجد وصف.",
  "copy.Hidedetails": "إخفاء التفاصيل",
  "copy.Moredetails": "المزيد من التفاصيل",
  "copy.Start": "البدء:",
  "copy.Speed": "السرعة:",
  "copy.Quality": "الجودة:",
  "copy.Refill": "إعادة التعبئة:",
  "copy.Link": "الرابط:",
  "copy.Notspecified": "غير محدد",
  "copy.Yes": "نعم",
  "copy.No": "لا",
  "copy.NoservicedescriptionhasbeenprovidedContactsupportfordetails": "لم يُقدّم وصف للخدمة. تواصل مع الدعم للتفاصيل.",
  "copy.Refillisenabledforthisservice": "إعادة التعبئة مفعّلة لهذه الخدمة.",
  "copy.Refillisnotenabledforthisservice": "إعادة التعبئة غير مفعّلة لهذه الخدمة.",
  "copy.Enterthelinkrequiredbythisservice": "أدخل الرابط المطلوب لهذه الخدمة",
  "copy.Checktheservicedescriptionfortherequiredlinktype": "راجع وصف الخدمة لمعرفة نوع الرابط المطلوب.",
  "copy.Supporttickets": "تذاكر الدعم",
  "copy.Retryformsettings": "إعادة تحميل إعدادات النموذج",
  "copy.Loadingticketform": "جارٍ تحميل نموذج التذاكر...",
  "copy.NewsupportticketsaredisabledforthisaccountExistingconversationsremainavailable": "إنشاء تذاكر جديدة معطّل لهذا الحساب. المحادثات الحالية ما زالت متاحة.",
  "copy.NoticketcategoriesareconfiguredContactthepaneladministrator": "لم تُعدّ فئات للتذاكر. تواصل مع مسؤول اللوحة.",
  "copy.Newticket": "تذكرة جديدة",
  "copy.Subject": "الموضوع",
  "copy.Subcategory": "الفئة الفرعية",
  "copy.OrderID": "رقم الطلب",
  "copy.Message": "الرسالة",
  "copy.Attachfiles": "إرفاق ملفات",
  "copy.Attachfilestonewticket": "إرفاق ملفات بالتذكرة الجديدة",
  "copy.PNGJPEGPDForUTF8textUpto5MiBperfileand10filesperticket": "ملفات PNG أو JPEG أو PDF أو نص UTF-8. الحد 5 ميبيبايت للملف و10 ملفات للتذكرة.",
  "copy.Submitting": "جارٍ الإرسال...",
  "copy.Submitticket": "إرسال التذكرة",
  "copy.Tickethistory": "سجل التذاكر",
  "copy.Yourtickets": "تذاكرك",
  "copy.Searchtickets": "بحث في التذاكر",
  "copy.TicketsubjectororderID": "رقم التذكرة أو موضوعها أو رقم الطلب",
  "copy.EnterorderIDoptional": "أدخل رقم الطلب (اختياري)",
  "copy.Status": "الحالة",
  "copy.Ticketstatus": "حالة التذكرة",
  "copy.Allstatuses": "جميع الحالات",
  "copy.Refreshtickets": "تحديث التذاكر",
  "copy.Loadingtickets": "جارٍ تحميل التذاكر...",
  "copy.Noticketsmatchthesefilters": "لا توجد تذاكر تطابق هذه المرشّحات.",
  "copy.Previoustickets": "التذاكر السابقة",
  "copy.Nexttickets": "التذاكر التالية",
  "copy.Ticketconversation": "محادثة التذكرة",
  "copy.Backtotickets": "العودة للتذاكر",
  "copy.Refreshconversation": "تحديث المحادثة",
  "copy.Loadingconversation": "جارٍ تحميل المحادثة...",
  "copy.Support": "الدعم",
  "copy.You": "أنت",
  "copy.Previousmessages": "الرسائل السابقة",
  "copy.Nextmessages": "الرسائل التالية",
  "copy.ThisticketisclosedCreateanotherticketifyouneedhelp": "هذه التذكرة مغلقة. أنشئ تذكرة أخرى إن احتجت مساعدة.",
  "copy.Replytoticket": "الرد على التذكرة",
  "copy.Reply": "الرد",
  "copy.Saving": "جارٍ الحفظ...",
  "copy.Sendreply": "إرسال الرد",
  "copy.Confirmticketclosure": "تأكيد إغلاق التذكرة",
  "copy.ClosethisticketReplieswillbedisabled": "هل تريد إغلاق هذه التذكرة؟ سيتوقف إرسال الردود.",
  "copy.Confirmclose": "تأكيد الإغلاق",
  "copy.Keepopen": "إبقاؤها مفتوحة",
  "copy.Closeticket": "إغلاق التذكرة",
  "copy.Retrycontent": "إعادة تحميل المحتوى",
  "copy.Loadingcontent": "جارٍ تحميل المحتوى...",
  "copy.Blog": "المدونة",
  "copy.Nopublishedarticlesyet": "لا توجد مقالات منشورة بعد.",
  "copy.Pageunavailable": "الصفحة غير متاحة",
  "copy.Thispageishiddenunpublishedorunavailabletothisaccount": "هذه الصفحة مخفية أو غير منشورة أو غير متاحة لهذا الحساب.",
  "copy.Nocontenthasbeenpublishedforthispageyet": "لم يُنشر محتوى لهذه الصفحة بعد.",
  "copy.Account": "الحساب",
  "copy.Logout": "تسجيل الخروج",
  "copy.Togglenavigation": "فتح قائمة التنقل",
  "copy.Retrymenu": "إعادة تحميل القائمة"
};
